import type { QueryClient } from "@tanstack/react-query";
import type {
  Attribute,
  AttributeParameter,
  AttributeType,
} from "pages/PeopleSettings/PeopleSettings";
import ApiService from "services/api.service";

export const CONTACT_ATTRIBUTE_QUERY_STALE_TIME = 5 * 60 * 1000;

export const contactAttributeQueryKeys = {
  all: ["contact-attribute-settings"] as const,
  attributes: ["contact-attribute-settings", "attributes"] as const,
  types: ["contact-attribute-settings", "types"] as const,
  parameters: ["contact-attribute-settings", "parameters"] as const,
};

export const contactAttributesQuery = () => ({
  queryKey: contactAttributeQueryKeys.attributes,
  queryFn: async (): Promise<Attribute[]> => {
    const { data } = await ApiService.get<Attribute[]>({
      url: `/contacts/possible-attributes?removeLimit=true&type=String&type=Number&type=Email&type=Boolean&type=Date&type=DateTime`,
    });
    return data;
  },
  staleTime: CONTACT_ATTRIBUTE_QUERY_STALE_TIME,
});

export const contactAttributeTypesQuery = () => ({
  queryKey: contactAttributeQueryKeys.types,
  queryFn: async (): Promise<AttributeType[]> => {
    const { data } = await ApiService.get<AttributeType[]>({
      url: `/contacts/possible-attribute-types`,
    });
    return data;
  },
  staleTime: CONTACT_ATTRIBUTE_QUERY_STALE_TIME,
});

export const contactAttributeParametersQuery = () => ({
  queryKey: contactAttributeQueryKeys.parameters,
  queryFn: async (): Promise<AttributeParameter[]> => {
    const { data } = await ApiService.get<
      Array<AttributeParameter & { isSystem?: boolean }>
    >({
      url: `/contacts/possible-attribute-parameters/`,
    });
    return data.filter((item) => !item.isSystem);
  },
  staleTime: CONTACT_ATTRIBUTE_QUERY_STALE_TIME,
});

export const prefetchContactAttributeSettings = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.prefetchQuery(contactAttributesQuery()),
    queryClient.prefetchQuery(contactAttributeTypesQuery()),
    queryClient.prefetchQuery(contactAttributeParametersQuery()),
  ]);
